module.exports = __webpack_public_path__ + "static/media/living-room.46eaaa3d.jpg";